export const table_config = {
  actions: {
    single: (tenant) => [
      [
        { label: 'View', value: 'view', hidden: !tenant.is_active },
        { label: 'Edit', value: 'edit', hidden: !tenant.is_active },
        { label: 'Top Up', value: 'top up', hidden: !tenant.is_active },
        { label: 'Assign Subscription', value: 'assign_subscription', hidden: !tenant.is_active },
        { label: 'Configure Retention', value: 'retention_config', hidden: !tenant.is_active },
        { label: 'Generate Invoice', value: 'generate_invoice', hidden: !tenant.is_active },
        { label: 'Mark as Internal', value: 'mark_internal', hidden: tenant.metadata?.is_internal }
      ],
      [{ label: 'Delete', value: 'delete' }]
    ]
  },
  allow_bulk_action: true,
  css: {},
  fields: [
    {
      title: 'ID',
      key: 'id'
    },
    {
      title: 'Name',
      key: 'name',
      isTitle: true,
      searchable: true
    },
    {
      title: 'Email',
      key: 'emails',
      formatter: (value) => value[0],
      searchable: true,
      isTagline: true
    },
    {
      title: 'Status',
      key: 'is_active',
      formatter: (value) => (value ? 'Active' : 'Inactive'),
      isTagline: true,
      searchable: true
    },
    {
      title: 'Balance',
      key: 'email',
      isTagline: true,
      formatter: (value) => value?.balance || '0'
    },
    {
      title: 'Rate',
      key: 'email',
      isTagline: true,
      formatter: (value) => value?.rate || 'N/A'
    },
    {
      title: 'Date added',
      key: 'created_on',
      formatter: (value) => {
        return value ? new Date(value).toDateString() : '';
      },
      isMetadata: true
    }
  ],
  items: [],
  search_key: 'name',
  search_text: ''
};
